
shadow.loader.set_loaded();